import { useGLTF, OrbitControls } from '@react-three/drei'
import { Perf } from 'r3f-perf'
import { InstancedRigidBodies, CylinderCollider, BallCollider, CuboidCollider, RigidBody, Physics } from '@react-three/rapier'
import { useMemo, useEffect, useState, useRef } from 'react'
import { useFrame } from '@react-three/fiber'
import * as THREE from 'three'
import { useControls } from 'leva'

export default function Experience()
{
    const cube = useRef()

    const { debugMode } = useControls({
        debugMode: true,
    })

    const { gravityScaleBlock, powerJump, bouncinessBlock, frictionBlock } = useControls('block settings', {
        powerJump: {
            value: 5,
            min: 0,
            max: 15,
            step: 0.1
        },
        gravityScaleBlock:
        {
            value: 1,
            min: 0,
            max: 5,
            step: 0.1
        },
        bouncinessBlock:
        {
            value: 0,
            min: 0,
            max: 5,
            step: 0.1
        },
        frictionBlock:
        {
            value: 0.7,
            min: 0,
            max: 1,
            step: 0.01
        },
    })

    const { bouncinessFloor, frictionFloor } = useControls('floor settings', {
        bouncinessFloor:
        {
            value: 0,
            min: 0,
            max: 5,
            step: 0.1
        },
        frictionFloor:
        {
            value: 0.7,
            min: 0,
            max: 1,
            step: 0.01
        },
    })

    const cubeJump = () =>
    {
        const mass = cube.current.mass()
        // If we wait too long, block will be sleeping, so we need to wake up it.
        cube.current.wakeUp()
        console.log(cube.current)
        cube.current.applyImpulse({ x: 0, y: powerJump * mass, z: 0 })
        cube.current.applyTorqueImpulse({ x: Math.random() - 0.5, y: Math.random() - 0.5, z: Math.random() - 0.5 })
    }

    return <>

        <Perf position="top-left" />
        <OrbitControls makeDefault />
        <directionalLight castShadow position={ [ 1, 2, 3 ] } intensity={ 1.5 } />
        <ambientLight intensity={ 0.5 } />

        <Physics debug={ debugMode } gravity={ [ 0, - 9.08, 0 ] }>
            <RigidBody
                ref={ cube }
                position={ [ 1.5, 2, 0 ] }
                gravityScale={ gravityScaleBlock }
                colliders={ false }
            >
                <mesh castShadow onClick={ cubeJump }>
                    <boxGeometry />
                    <meshStandardMaterial color="mediumpurple" />
                </mesh>
                <CuboidCollider
                    mass={ 1 }
                    args={ [ 0.5, 0.5, 0.5 ] }
                    restitution={ bouncinessBlock }
                    friction={ frictionBlock }
                />
            </RigidBody>

            <RigidBody
                type="fixed"
                colliders={ false }
                position-y={ - 1.25 }

            >
                <mesh receiveShadow>
                    <boxGeometry args={ [ 10, 0.5, 10 ] } />
                    <meshStandardMaterial color="greenyellow" />
                </mesh>
                <CuboidCollider
                    args={ [ 5, 0.25, 5 ] } // La moitié de la taille
                    restitution={ bouncinessFloor }
                    friction={ frictionFloor }
                />
            </RigidBody>


            <RigidBody type="fixed">
                <CuboidCollider args={ [ 5, 20, 0.5 ] } position={ [ 0, 1, 5.25 ] } />
                <CuboidCollider args={ [ 5, 20, 0.5 ] } position={ [ 0, 1, - 5.25 ] } />
                <CuboidCollider args={ [ 0.5, 20, 5 ] } position={ [ 5.25, 1, 0 ] } />
                <CuboidCollider args={ [ 0.5, 20, 5 ] } position={ [ - 5.25, 1, 0 ] } />
            </RigidBody>

        </Physics>

    </>
}
